import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import type { JSX } from 'react';
import { defaultPadding, paddingMap } from './config.ts';
import { Indentation } from './Indentation.tsx';
import type { HighlightedSectionProps, PaperPadding } from './types.ts';

const StyledDiv = styled('div')<{ padding: string }>(({ theme, padding }) => ({
  background: theme.palette.background.boxLight,
  padding: paddingMap[padding],
}));

export const makeHighlightedSection =
  (padding: PaperPadding = defaultPadding) =>
  ({ children, className }: HighlightedSectionProps): JSX.Element => (
    <Indentation padding={padding} className={className}>
      <Divider />
      <StyledDiv padding={padding}>{children}</StyledDiv>
      <Divider />
    </Indentation>
  );
